import React from 'react';
import ReactDOM from 'react-dom';
import App from './pages/App';
import { Provider as ReduxProvider } from "react-redux";
import configureStore from "./modules/store";
import { saveState, loadState } from "./modules/localStorage";
import throttle from "lodash/throttle";

import registerServiceWorker from './registerServiceWorker';

const reduxStore = configureStore(loadState());

reduxStore.subscribe(throttle(() => {
    saveState(reduxStore.getState());
}, 1000));

ReactDOM.render(
    <ReduxProvider store={reduxStore}>
        <App />
    </ReduxProvider>,
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js